import "react-tooltip/dist/react-tooltip.css";
import "tippy.js/dist/tippy.css";
import "tippy.js/themes/light-border.css";

import { useQuery } from "@tanstack/react-query";
import classNames from "classnames";
import { useEffect } from "react";
import { useParams } from "react-router-dom";

import { Header, PageReadOnly } from "@/components";
import FullPageLoader from "@/components/FullPageLoader";
import { useQueries } from "@/hooks";

import styles from "./App.module.scss";
import { getDefaultPageId } from "./hooks/useQueries/pages";

export default function Public() {
  let { pageId } = useParams();

  const { projects, currentProject } = useQueries();

  const { data: defaultPageId } = useQuery({
    queryKey: ["default-page"],
    queryFn: ({ signal }) => getDefaultPageId(signal, currentProject?.id),
    enabled: Boolean(currentProject?.id),
    retry: false,
  });

  useEffect(() => {
    if (currentProject) {
      document.title = `${currentProject?.slug} - coordination.network`;
    }
  }, [projects, currentProject]);

  return (
    <>
      {!currentProject ? <FullPageLoader /> : <></>}
      <div className={`${styles.wrapper} App`}>
        <Header />
        <PageReadOnly
          id={defaultPageId}
          className={classNames(styles.page)}
          nodePageOpen={Boolean(pageId)}
        />
        {Boolean(pageId) && (
          <PageReadOnly
            id={pageId}
            key={`page-${pageId}`}
            className={classNames(styles.page, styles.nodePage)}
            nodePageOpen={Boolean(pageId)}
            isNodePage
          />
        )}
      </div>
    </>
  );
}
